export enum COUNTRY_ID {
    GB = 77,
    US = 232,
}

export enum COUNTRY_CODE {
    GB = 'GB',
    US = 'US',
}
